import Cookies from 'universal-cookie';
import jwt_decode from 'jwt-decode';
import { IAccessToken, TUserRoles } from '../types';

const cookies = new Cookies();

/** функция установки токенов авторизации */
const setCookies = (accessToken: string, refreshToken: string,) => {
  cookies.set('accessToken', accessToken);
  cookies.set('refreshToken', refreshToken);
};

/** функциия удаления куков авторизации */
const removeCookies = (): void => {
  cookies.remove('accessToken');
  cookies.remove('refreshToken');
};

/** функция выхода из аккаунта */
const logout = (): void => {
  removeCookies();
};

/** функция для получения токена по типу токена */
const getToken = (tokenType: 'accessToken' | 'refreshToken'): string => {
  return cookies.get(tokenType) ?? null;
};

/** функция для получения id юзера */
const getUserId = (): number => {
  const cookie = cookies.get('accessToken');
  return cookie ? +jwt_decode<IAccessToken>(cookie).sub ?? null : null;
}
  
/** функция для получения списка ролей юзера */
const getUserRoles = (): TUserRoles[] =>
  (jwt_decode<IAccessToken>(cookies.get('accessToken')) as IAccessToken).roles ?? null;

/** функция для получения id пользователя из куки */
const getUserIdFromCookie = (): number => {
  const user = cookies.get('user');
  return user.id ?? null;
};

/** функция для обновления acess токена */
const updateAccessToken = (token: string) => {
  cookies.set('accessToken', token);
};

/** константа для импорта основных функций */
export const AuthService = {
  logout,
  getToken,
  getUserId,
  getUserRoles,
  getUserIdFromCookie,
  updateAccessToken,
  setCookies,
  removeCookies,
};

export default AuthService;
